export function formatAmount(value: number): string {
    const absValue = Math.abs(value);
    const rubles = Math.floor(absValue / 100);
    const kopecks = absValue % 100;

    const rublesFormatted = `${rubles}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const kopecksFormatted = `${kopecks}`.padStart(2, '0');
    const sign = value < 0 ? '-' : '';

    return `${sign}${rublesFormatted}.${kopecksFormatted}`;
}
